interface FreeLimitModeBannerProps {
  readonly spaceName?: string;
  readonly graceDaysRemaining?: number;
  readonly graceDaysTotal?: number;
  readonly reason?: string;
}

export function FreeLimitModeBanner({
  spaceName = "Free Limit Mode placeholder",
  graceDaysRemaining = 14,
  graceDaysTotal = 14,
  reason = "Spaces that exceed Free limits after a paid period ends may enter a grace period before paid-only features are restricted."
}: FreeLimitModeBannerProps) {
  return (
    <section className="free-limit-banner" aria-label="Free Limit Mode notice">
      <div className="free-limit-banner-header">
        <span className="status-chip warning">Free Limit Mode</span>
        <strong>{spaceName}</strong>
      </div>
      <p>
        {reason} {graceDaysRemaining} of {graceDaysTotal} grace days remain in
        this mock example.
      </p>
    </section>
  );
}
